<div class="d-flex flex-column flex-auto">
  <span class="confirm-popup-title">{{'bulk_upload_influencer.modal.title' | translate}}</span>
  <span class="modal-subtitle">
    {{'bulk_upload_influencer.modal.subtitle' | translate}}
    <a class="download-template"
       href="https://static2.getachoo.com/sample.csv" download>
      {{'bulk_upload_influencer.modal.download_template' | translate}}
    </a>
  </span>
  <achoo-textarea placeholder="{{'bulk_upload_influencer.modal.textarea_placeholder' | translate}}"
                  [(model)]="bulkUploadInfluencerInputValue"
                  (input)="inputEvent()"
                  (focusout)="focusoutEvent()">
  </achoo-textarea>
  <span class="validation-erro-msg">{{validationErrorMsg}}</span>
  <div class="d-flex flex-row">
    <div class="d-flex flex-auto align-items-center">
      <achoo-checkbox label="{{'bulk_upload_influencer.modal.checkbox_text' | translate}}"
                      [(model)]="bulkUploadInfluencer.shouldNotify">
      </achoo-checkbox>
    </div>
    <div class="d-flex flex-auto justify-content-end">
      <button class="button sm-button blue continue-btn"
              [disabled]="disableContinueButton"
              (click)="uploadBulkInfluencer()">
        {{'common.btn.continue' | translate}}
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/bottombar-influencer-fragement/bulk-upload-influencer/bulk-upload-influencer-modal/bulk-upload-influencer-modal.component.html